// src/components/WelcomeWidget.js
import React from 'react';
import { useAuth } from '@workos-inc/authkit-react';
import { getBranding } from '../scripts/branding';
import './WelcomeWidget.css';

const WelcomeWidget = () => {
  const { user } = useAuth();
  const branding = getBranding();

  const firstName = user?.firstName || 'there';
  const toolsetName = branding.toolName === 'Armory' ? 'Armory tools' : 'BuddyTools';

  let toolMessage;
  if (branding.toolName === 'Armory') {
    toolMessage = "Here is your Tool Kit. Let's get to work.";
  } else if (branding.toolName === 'BuddyTools') {
    toolMessage = "Here are your BuddyTools. Let's get to work.";
  } else {
    toolMessage = "Here are your available tools. Let's get to work.";
  }

  return (
    <div className="welcome-widget">
      <h2>Welcome back, {firstName}!</h2>
      <p>{toolMessage}</p>
    </div>
  );
};

export default WelcomeWidget;
